<template>
  <nav class="my-page-sidebar-nav">
    <p class="my-page-sidebar-nav_title">マイページメニュー</p>
    <ul class="my-page-sidebar-nav_list">
      <li v-for="item in MYPAGE_SIDEBAR_NAV_ITEMS" :key="item.to">
        <!--
          **長いラベルだけ文字を落とす。** 支給に無い「アンケートキャンペーン」が
          16px だと矢印に重なって2行になるため（下の `<style>`）。
        -->
        <NuxtLink
          :to="item.to"
          class="my-page-sidebar-nav-item"
          :class="{ 'is-long-label': item.label.length >= LONG_LABEL_LENGTH }"
        >
          {{ item.label }}
          <span class="my-page-sidebar-nav-item_arrow" aria-hidden="true"></span>
        </NuxtLink>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `my-page-sidebar-nav`（マイページメニュー6件）。
 *
 * **PC の2カラム左（`organisms/mypage/sidebar.vue`）と SP のフッター上
 * （`organisms/layouts/sidebar/index.vue`）で同じものを出す**ので部品にしてある。
 * 支給CSS は PC 用しか持たないが、SP 側は幅100%の親（`.sidebar.sp-only`）に入るだけで
 * そのまま成立するため追加のCSSは持たない。
 */
import { MYPAGE_SIDEBAR_NAV_ITEMS } from '@/consts/MypageConst';

/** これ以上の文字数のラベルは1行に収まらないので文字を落とす（下の `<style>`） */
const LONG_LABEL_LENGTH = 10;
</script>

<style scoped>
/**
 * **「アンケートキャンペーン」だけ1行に収まらないので、この項目だけ文字を落とす**（§3.8・決定#76）。
 *
 * 支給のラベルは最長でも「退会のお申し込み」（16px で 111px）で、`my-page-sidebar-nav-item` の
 * 内側 162px に余裕があった。**「アンケートキャンペーン」は 16px だと約165px**で入らず、
 * さらに右端 16px に矢印が絶対配置（`renewal/style.css:5530`）されているため、
 * 中央寄せのテキストが矢印に重なって折り返していた。
 *
 * 全項目の文字を下げると支給の見た目が変わるので、**長いものだけ縮める** —
 * 14px なら約144px で、矢印の左端（178px）までに収まる。
 */
.my-page-sidebar-nav-item {
  font-size: 16px;
}

/* 「アンケートキャンペーン」（11文字）だけが該当する */
.my-page-sidebar-nav-item.is-long-label {
  font-size: 14px;
}
</style>
